import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getcarModelLanding = (id) => {
  const url = API_URLS.carModel(id);
  return axiosClient.get(url);
};
